
export function useClipboard({buttonSelector = 'btn-cpy', icon = 'bi-clipboard',checkIconClass = 'bi-check-all',
    checkIconSize = 'fs-2', checkIconColor = 'text-primary', successMessage = 'Copied!'} = {}) {
    let clipboard;

    const initCopyToClipboard = () => {
        clipboard = new ClipboardJS(`.${buttonSelector}`);
        clipboard.on('success', function(e) {

        const target = document.querySelector(`[data-clipboard-text="${e.text}"]`);
        if (!target) {
            console.warn('Aucun bouton trouvé avec ce texte copié.');
            return;
        }

        const clipboardIcon = target.querySelector(`.bi.${icon}`);

        let checkIcon = target.querySelector(`.bi.${checkIconClass}`);
        if (checkIcon) {
            return;
        }

        checkIcon = document.createElement('i');
        checkIcon.classList.add('bi', checkIconClass, checkIconSize, checkIconColor);
        target.appendChild(checkIcon);

        if (clipboardIcon) {
            clipboardIcon.classList.add('d-none');
        }

        target.setAttribute('title', successMessage);

        const tooltip = new bootstrap.Tooltip(target);
        tooltip.show();

        setTimeout(function () {
            target.removeChild(checkIcon);
            if (clipboardIcon) {
                clipboardIcon.classList.remove('d-none');
            }
            target.setAttribute('title', e.trigger.getAttribute('title'));
            tooltip.hide();
            }, 3000);
        });

        clipboard.on('error', function(e) {
        console.error('Action:', e.action);
        console.error('Trigger:', e.trigger);
    });
};

return {initCopyToClipboard}
}